import React from 'react'

export const SocialCardLineHeight = ({ lineHeight, className = "", setLineHeight }) => {
	return (
		<div className={`form-group ${className}`}>
			<label>Line height</label>
			<input
				type="number"
				value={lineHeight}
				onChange={(e) => setLineHeight(e.target.value)}
				className="form-control"
			/>
		</div>
	)
}
